<!-- Açılır menü (16.10.2026): daraltılmış sol menünün ikon şeridi + basamaklı pencereler. Bkz. ACILIR_MENU_AKTIF -->
<!-- eski hâli (17.10.2026): <nav class="serit" aria-label="Menü"> -->
<nav class="serit" aria-label="Menü" (mouseenter)="seritGirdi()" (mouseleave)="seritCikti()">
  <button type="button" class="serit-dugme ozel" [class.acik]="acikKok === 'ara'" title="Form Arama" aria-label="Form Arama" (click)="araAc($event)">
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>
  <button type="button" class="serit-dugme ozel fav" [class.acik]="acikKok === 'fav'" title="Favorilerim" aria-label="Favorilerim" (click)="favAc($event)">
    <i class="dx-icon dx-icon-favorites"></i>
  </button>
  <div class="serit-ayrac"></div>

  <!-- eski hâli (17.10.2026): <div class="serit-liste"> -->
  <div #seritListe class="serit-liste">
    <button
      *ngFor="let oge of menu; trackBy: izle"
      type="button"
      class="serit-dugme"
      [class.acik]="acikKok === oge"
      [style.--r]="oge.renk"
      [title]="oge.text"
      [attr.aria-label]="oge.text"
      [attr.aria-haspopup]="altVar(oge) ? 'menu' : null"
      [attr.aria-expanded]="altVar(oge) ? acikKok === oge : null"
      (click)="kokTikla(oge, $event)"
      (mouseenter)="kokUzerinde(oge, $event)"
      (mouseleave)="kokCikti()"
    >
      <span class="serit-ikon"><i [class]="ikonSinifi(oge)"></i></span>
    </button>
  </div>

  <button type="button" class="serit-dugme genislet" title="Menüyü genişlet (ağaç görünümü)" aria-label="Menüyü genişlet" (click)="kapat(); genislet.emit()">
    <i class="fa-solid fa-angles-right"></i>
  </button>
</nav>

<!-- 17.10.2026 favori yıldızı (satır button olduğu için iç içe button değil span): favorideyse dolu ve hep görünür,
     değilse satırın üstüne gelince boş yıldız. Tıklama formu açmaz. -->
<ng-template #favYildiz let-oge>
  <span
    *ngIf="favoriOlabilir(oge)"
    class="acilir-fav"
    [class.dolu]="favoriMi(oge)"
    role="button"
    tabindex="-1"
    [title]="favoriMi(oge) ? 'Favorilerden kaldır' : 'Favorilere ekle'"
    [attr.aria-label]="favoriMi(oge) ? 'Favorilerden kaldır' : 'Favorilere ekle'"
    (click)="favoriTikla(oge, $event)"
  ><i [class]="favoriMi(oge) ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i></span>
</ng-template>

<!-- Pencereler: ngAfterViewInit'te body'ye taşınır -->
<div #katman class="acilir-katman">
  <!-- Adlı şerit (17.10.2026): fare dar şeritte durunca aynı hizada, içeriğin üstüne binerek modül adlarıyla açılır.
       Düğmeler dar şeritle aynı sırada ve yükseklikte (ikonlar yerinden oynamaz). -->
  <nav
    *ngIf="genis"
    class="serit genis-serit"
    aria-label="Menü"
    [style.top.px]="genisKonum.top"
    [style.left.px]="genisKonum.left"
    [style.height.px]="genisKonum.height"
    [style.width.px]="genisGenislik"
    (mouseenter)="genisGirdi()"
    (mouseleave)="genisCikti()"
  >
    <button type="button" class="serit-dugme ozel" [class.acik]="acikKok === 'ara'" (click)="araAc($event)">
      <span class="serit-ikon-yer"><i class="fa-solid fa-magnifying-glass"></i></span>
      <span class="serit-ad">Form Arama</span>
    </button>
    <button type="button" class="serit-dugme ozel fav" [class.acik]="acikKok === 'fav'" (click)="favAc($event)">
      <span class="serit-ikon-yer"><i class="dx-icon dx-icon-favorites"></i></span>
      <span class="serit-ad">Favorilerim</span>
    </button>
    <div class="serit-ayrac"></div>

    <div #genisListe class="serit-liste">
      <button
        *ngFor="let oge of menu; trackBy: izle"
        type="button"
        class="serit-dugme"
        [class.acik]="acikKok === oge"
        [style.--r]="oge.renk"
        [title]="oge.text"
        [attr.aria-haspopup]="altVar(oge) ? 'menu' : null"
        [attr.aria-expanded]="altVar(oge) ? acikKok === oge : null"
        (click)="kokTikla(oge, $event)"
        (mouseenter)="kokUzerinde(oge, $event)"
        (mouseleave)="kokCikti()"
      >
        <span class="serit-ikon"><i [class]="ikonSinifi(oge)"></i></span>
        <span class="serit-ad">{{ oge.text }}</span>
        <i *ngIf="altVar(oge)" class="fa-solid fa-chevron-right serit-ok"></i>
      </button>
    </div>

    <button type="button" class="serit-dugme genislet" (click)="kapat(); genislet.emit()">
      <span class="serit-ikon-yer"><i class="fa-solid fa-angles-right"></i></span>
      <span class="serit-ad">Menüyü genişlet</span>
    </button>
  </nav>

  <div
    *ngFor="let p of pencereler; let seviye = index"
    class="acilir-pencere"
    role="menu"
    [style.top.px]="p.top"
    [style.left.px]="p.left"
    [style.max-height.px]="p.maxHeight"
    [style.--r]="p.renk"
  >
    <div class="acilir-baslik">
      <span class="acilir-baslik-ikon" *ngIf="p.tur === 'menu'"><i [class]="p.ikon"></i></span>
      <span class="acilir-baslik-ikon fav" *ngIf="p.tur === 'fav'"><i class="dx-icon dx-icon-favorites"></i></span>
      <span class="acilir-baslik-ad">{{ p.baslik }}</span>
    </div>

    <!-- Form arama -->
    <ng-container *ngIf="p.tur === 'ara'">
      <div class="acilir-ara">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          #aramaKutusu
          type="text"
          placeholder="Form adı yazın…"
          autocomplete="off"
          [value]="aramaMetni"
          (input)="aramaYaz($any($event.target).value)"
          (keydown)="aramaTus($event)"
        />
      </div>
      <div class="acilir-liste">
        <div class="acilir-bos" *ngIf="aramaMetni.trim().length < 2">En az 2 harf yazın · ↑↓ seç · Enter aç</div>
        <div class="acilir-bos" *ngIf="aramaMetni.trim().length >= 2 && !aramaSonuclari.length">Eşleşen form yok</div>
        <button
          *ngFor="let s of aramaSonuclari; let i = index"
          type="button"
          class="acilir-satir arama"
          role="menuitem"
          [class.secili]="i === aramaSecili"
          [style.--r]="s.renk"
          [title]="s.yol ? s.yol + ' › ' + s.oge.text : s.oge.text"
          (mouseenter)="aramaSecili = i"
          (click)="aramaSonucTikla(s, $event)"
          (contextmenu)="favoriTikla(s.oge, $event)"
        >
          <span class="acilir-satir-ikon"><i [class]="ikonSinifi(s.oge)"></i></span>
          <span class="acilir-satir-metin">
            <span class="acilir-satir-ad">{{ s.oge.text }}</span>
            <span class="acilir-satir-yol" *ngIf="s.yol">{{ s.yol }}</span>
          </span>
          <ng-container *ngTemplateOutlet="favYildiz; context: { $implicit: s.oge }"></ng-container>
        </button>
      </div>
    </ng-container>

    <!-- Modül / klasör içeriği ve favoriler -->
    <div class="acilir-liste" *ngIf="p.tur !== 'ara'">
      <!-- eski hâli (17.10.2026): 'Henüz favori yok — ağaç menüde forma sağ tıklayıp ekleyin' -->
      <div class="acilir-bos" *ngIf="!p.ogeler.length">{{ p.tur === 'fav' ? 'Henüz favori yok — menüde formun yanındaki ☆ ile ekleyin' : 'Boş' }}</div>
      <button
        *ngFor="let oge of p.ogeler; trackBy: izle"
        type="button"
        class="acilir-satir"
        role="menuitem"
        [class.klasor]="altVar(oge)"
        [class.acik]="p.acikOge === oge"
        [attr.aria-haspopup]="altVar(oge) ? 'menu' : null"
        [title]="oge.text"
        (mouseenter)="satirUzerinde(seviye, oge, $event)"
        (mouseleave)="satirCikti()"
        (click)="satirTikla(seviye, oge, $event)"
        (contextmenu)="favoriTikla(oge, $event)"
      >
        <span class="acilir-satir-ikon" [class.fav]="p.tur === 'fav'"><i [class]="p.tur === 'fav' ? 'dx-icon dx-icon-favorites' : ikonSinifi(oge)"></i></span>
        <span class="acilir-satir-ad">{{ oge.text }}</span>
        <i *ngIf="altVar(oge)" class="fa-solid fa-chevron-right acilir-ok"></i>
        <ng-container *ngTemplateOutlet="favYildiz; context: { $implicit: oge }"></ng-container>
      </button>
    </div>
  </div>
</div>
